export enum Gender {
    MALE = 'M',
    MALE_LONG = 'MALE',
    FEMALE = 'F',
    FEMALE_LONG = 'FEMALE',
    UNKNOWN = ''
}
